// extracted by mini-css-extract-plugin
export default {"content":"ModalColeta_content__RQkYY","wrap_coleta":"ModalColeta_wrap_coleta__oREBd"};